document.addEventListener(
  'click',
  function (e) {
    var stickyButton = e.target.closest('product-sticky-bar button');
    if (!stickyButton) return;

    var stickyBar = stickyButton.closest('product-sticky-bar');
    if (!stickyBar) return;

    var formId = stickyBar.getAttribute('form');
    if (!formId) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    var candidates = document.querySelectorAll(
      'buy-buttons[form="' + formId + '"] button'
    );
    var mainButton = null;
    candidates.forEach(function (btn) {
      if (!stickyBar.contains(btn)) {
        mainButton = btn;
      }
    });

    if (!mainButton) return;

    // 用 Globo 下拉框实际显示的文字做判断依据（比原生 checked 状态更可靠）
    // 记录页面首次加载时的占位文字，之后拿当前文字跟它比对：没变 = 还没选
    var valueEl = document.querySelector('.dropdown-button-gsw__value');
    var stillPlaceholder = false;

    if (valueEl) {
      var initialText = valueEl.getAttribute('data-sticky-fix-initial');
      if (initialText === null) {
        initialText = valueEl.textContent.trim();
        valueEl.setAttribute('data-sticky-fix-initial', initialText);
      }
      stillPlaceholder = valueEl.textContent.trim() === initialText;
    }

    if (stillPlaceholder) {
      // 还没选,滚回主区域,让 Globo 的红字提示显示出来
      mainButton.scrollIntoView({ behavior: 'smooth', block: 'center' });
      setTimeout(function () {
        mainButton.click();
      }, 300);
    } else {
      // 已经选好了,直接加入购物车,不用跳转
      mainButton.click();
    }
  },
  true
);